import { createAction } from "redux-actions";
import {
  SET_PAYMENT_DATA,
  RESET_PAYMENT_DATA,
  UPDATE_AUTO_PAY,
  INITIATE_PAYMENT,
  UPDATE_ORDER_LISTING,
  PROMO_VALIDATION,
} from "./type";

export const setPaymentData = createAction(SET_PAYMENT_DATA);
export const resetPaymentData = createAction(RESET_PAYMENT_DATA);
export const updateAutoPay = createAction(UPDATE_AUTO_PAY);
export const initiatePayment = createAction(INITIATE_PAYMENT);
export const initiatePromoValidation = createAction(PROMO_VALIDATION);
export const updateOrderListing = createAction(UPDATE_ORDER_LISTING);
